import * as InquiryPositionWithDetails from './InquiryPositionWithDetails'
import {array, boolean, Decoder, field, nullable, object} from 'json-bouncer'
import {Company, companyDecoder} from './Company'
import {Offer, offerDecoder} from './Offer'
import {InquiryProofCopy, inquiryProofCopyDecoder} from './InquiryProofCopy'
import {Totals, totalsDecoder} from './Totals'
import {
    InquiryHistoryEntryWithUsers,
    inquiryHistoryEntryWithUsersDecoder
} from './InquiryHistoryEntryWithUsers'
import {Inquiry, inquiryDecoder} from './Inquiry'
import {BpsUser, bpsUserDecoder} from './BpsUser'

export interface InquiryWithDetails {
    readonly inquiry: Inquiry
    readonly inquiryPositionsWithAttachments: InquiryPositionWithDetails.InquiryPositionWithDetails[]
    readonly company: Company
    readonly history: InquiryHistoryEntryWithUsers[]
    readonly offers: Offer[]
    readonly totals: Totals
    readonly isForBalke: boolean
    readonly inquiryProofCopy: InquiryProofCopy | null
    readonly bpsUser: BpsUser
}

export function decoder(): Decoder<InquiryWithDetails> {
    return object({
        inquiry: field('inquiry', inquiryDecoder()),
        inquiryPositionsWithAttachments:
            field(
                'inquiryPositionsWithAttachments',
                array(InquiryPositionWithDetails.decoder())
            ),
        company: field('company', companyDecoder()),
        history:
            field(
                'inquiryHistory',
                array(inquiryHistoryEntryWithUsersDecoder()),
            ),
        offers: field('offers', array(offerDecoder())),
        totals: field('totals', totalsDecoder()),
        isForBalke: field('isForBalke', boolean()),
        inquiryProofCopy:
            field(
                'inquiryProofCopy',
                nullable(inquiryProofCopyDecoder()),
            ),
        bpsUser: field('bpsUser', bpsUserDecoder()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryWithDetails.ts